import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import type { QuizQuestion } from '../../../../context/QuizContext';
import SwirlIllustrations from '../../../SwirlIllustrations';
import WebformQuizRadiosWithImageImage from '../../QuizRadiosWithImage/Image';
import Thumb from '../Thumb';

import './style.scss';

export interface WebformQuizQuestionInfoProps {
  question: QuizQuestion;
  className?: string;
}

const WebformQuizQuestionInfo: React.FC<WebformQuizQuestionInfoProps> = (props) => {
  const { question, className } = props;

  const { t } = useTranslation();

  const classNames = c('WebformQuiz__QuestionInfo', className);

  return (
    <div className={classNames}>
      <header className="WebformQuiz__QuestionInfo__hero">
        <Container>
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <div className="WebformQuiz__QuestionInfo__hero__title">
                <h1>{question.title}</h1>
              </div>

              <div className="WebformQuiz__QuestionInfo__hero__result">
                <h2 className="asH4">{t('webform.quiz.question_info.your_answer_title')}</h2>
                <ul>
                  {question.givenAnswers.map((item) => (
                    <li key={`given-answer:${item}`}>
                      {question.type === 'quiz_radios_with_image' ? (
                        <WebformQuizRadiosWithImageImage
                          src={question.images?.[item]?.source || ''}
                          styles={question.images?.[item]?.styles || {}}
                          alt={question.options[item] || ''}
                        />
                      ) : (
                        <>
                          <Thumb
                            className="WebformQuiz__QuestionInfo__hero__result__thumb"
                            direction={question.isCorrect ? 'up' : 'down'}
                          />
                          {question.options[item]}
                        </>
                      )}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="WebformQuiz__QuestionInfo__hero__result">
                <h2 className="asH4">{t('webform.quiz.question_info.correct_answer_title')}</h2>
                <ul>
                  {question.correctAnswers.map((item) => (
                    <li key={`correct-answer:${item}`}>
                      {question.type === 'quiz_radios_with_image' ? (
                        <WebformQuizRadiosWithImageImage
                          src={question.images?.[item]?.source || ''}
                          styles={question.images?.[item]?.styles || {}}
                          alt={question.options[item] || ''}
                        />
                      ) : (
                        <>
                          <Thumb
                            className="WebformQuiz__QuestionInfo__hero__result__thumb"
                            direction="up"
                          />
                          {question.options[item]}
                        </>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Container>

        <SwirlIllustrations variant="quiz_info" />
      </header>

      <main className="WebformQuiz__QuestionInfo__read-more">
        <Container>
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <h2 className="asH4">{t('general.more_info')}</h2>

              <WysiwygField
                property="schema:text"
                html={question.readMore}
              />
            </div>
          </div>
        </Container>
      </main>
    </div>
  );
};

export default WebformQuizQuestionInfo;
